import { Link } from "react-router-dom";
import img1 from "../../assets/Images/Expense/expense list.png"
import img2 from "../../assets/Images/Expense/create expense .png"
import DocNavigation from "../../components/DocNavigation";

export default function Expense() {
    return (
        <section id="expense" className="space-y-16">

            {/* SECTION TITLE */}

            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-4">
                    Expense Module
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    The Expense module allows you to record, track, and manage all
                    operational expenses incurred during daily banquet operations.  Expense Management ensures that every outgoing payment — whether for
                    utilities, maintenance, labor, or operational costs — is recorded
                    accurately and reflected in financial reports.
                </p>
            </section>

            {/* <div>
                <h2 className="text-xl font-semibold text-[#C9A24E] mb-3">
                    Expense Module
                </h2>
                <p className="text-slate-600 max-w-3xl">
                    The Expense module allows you to record, track, and manage all
                    operational expenses incurred during daily banquet operations.
                </p>
            </div> */}

            {/* OVERVIEW */}
            {/* <section className="bg-white border-l-4 border-[#C9A24E] rounded-lg p-6">
                <h3 className="font-semibold mb-2">Overview</h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                    Expense Management ensures that every outgoing payment — whether for
                    utilities, maintenance, labor, or operational costs — is recorded
                    accurately and reflected in financial reports.
                </p>
            </section> */}

            {/* EXPENSE LIST */}
            <section className="p-4">
                <div>
                    <h3 className="font-semibold mb-2">
                        Expense List
                    </h3>

                    <p className="text-slate-600 mb-4">
                        When the Expense module is opened, a table displays all recorded
                        expenses with essential details.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Expense Account (e.g. Gas Bill, Electric Bill, etc.)</li>
                        <li>Expense Amount</li>
                        <li>Payment Type (Cash, Bank, Online, etc.)</li>
                        <li>Date of expense</li>
                        <li>Description / remarks</li>
                        <li>Edit & Delete actions</li>
                    </ul>
                </div>

                <div className="rounded-lg p-2 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ADD EXPENSE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Adding a New Expense
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Add New</strong> button opens the Create Expense
                    form where a new expense entry can be recorded.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Expense Account:</strong> Select the expense category
                        (Gas Bill, Electric Bill, Carpenter Labor, etc.)
                    </li>
                    <li>
                        <strong>Date:</strong> Date on which the expense was paid or incurred
                    </li>
                    <li>
                        <strong>Payment Type:</strong> Cash, Cheque, Online, Bank Transfer, etc.
                    </li>
                    <li>
                        <strong>Amount:</strong> Enter the expense amount
                    </li>
                    <li>
                        <strong>Description:</strong> Optional remarks for reference
                    </li>
                </ul>

                <p className="text-slate-600 mt-3">
                    After filling in the required fields, click <strong>Create</strong> to
                    save the expense or <strong>Reset</strong> to clear the form.
                </p>

                <div className="bg-slate-100 rounded-lg p-4 text-sm text-slate-500 mt-4">
                    <img src={img2} alt="" />
                </div>
            </section>

            {/* EDIT EXPENSE */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Editing an Expense
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Edit</strong> action opens the same expense form
                    with all fields pre-filled using existing data.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Modify amount or payment type</li>
                    <li>Correct expense account selection</li>
                    <li>Update description or date</li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Once saved, changes are immediately reflected in reports and summaries.
                </p>
            </section>

            {/* DELETE EXPENSE */}
            <section className="bg-red-50 border border-red-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2 text-red-700">
                    Deleting an Expense
                </h3>

                <p className="text-slate-600 mb-3">
                    The <strong>Delete</strong> action removes an expense entry permanently
                    from the system.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Confirmation prompt appears before deletion</li>
                    <li>Deleted expenses cannot be recovered</li>
                    <li>Use with caution for audit accuracy</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Expense Tracking Matters
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Accurate expense tracking helps maintain financial transparency,
                    improves profit analysis, supports audits, and ensures better
                    operational decision-making.
                </p>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, explore{" "}
                    <Link to="/docs/Procurement" className="font-medium text-[#C9A24E]">
                       Procurement Module
                    </Link>.
                </p>
            </section> */}

            <DocNavigation
                previous={{
                    title: "Online Reservations Module",
                    link: "/docs/"
                }}
                next={{
                    title: "Procurement Module",
                    link: "/docs/Procurement"
                }}
            />

        </section>

    );
}
